$(document).ready(function() {
$("body").on("click touchstart", ".add__to__cart", function(e) {
  e.preventDefault();
  var variantId = $(this).attr("variant-id");
  var available = $(this).attr("variant-available");
  var type = $(this).attr("button-type");
  if (available === "true" || available === true) {
    if (variantId) {
      var qty = 1;
      if (type === "product") {
        qty = $(".product__qty--container .quantity__current").val();
      }
      var objUpdate = { quantity: qty, id: variantId };
      if ($(this).hasClass('giftCard')){
        var mail = $('#recipient-mail-destinataire').val()
        var name = $('#recipient-name').val()
        var message = $('#recipient-message').val()
        var date = $('#recipient-date').val()

        var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

        if (!mail) {
          $('.error-mail').show()
          setTimeout(function(){
            $('.error-mail').hide()
          }, 2000);
          return;
        } else if (!emailRegex.test(mail)){
          $('.error-mail-mail').show()
          setTimeout(function(){
            $('.error-mail-mail').hide()
          }, 2000);
          return;
        } else if (!name){
          $('.error-name').show()
          setTimeout(function(){
            $('.error-name').hide()
          }, 2000);
          return;
        } else if (!date){
          $('.error-date').show()
          setTimeout(function(){
            $('.error-date').hide()
          }, 2000);
          return;
        }

        objUpdate.properties = {
          __shopify_send_gift_card_to_recipient: true,
          'Recipient email': mail,
          'Recipient name': name,
          Message: message,
          'Send on': date
        }
      }
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: objUpdate,
        dataType: "json",
        success: function() {
          updateCartData(true);
          renderCart();
          document.dispatchEvent(new CustomEvent("update-reco-drawer"));

          if ($("#empty__cart--title").length > 0) {
            location.reload(true);
          }

          document.dispatchEvent(new CustomEvent("cart:open"));
          $(this).children(".button--text").css("display", "block");
          $(this).children(".button--loading").css("display", "none");
        },
        error: function(error) {
          console.log(error);
        }
      });
    } else {
      console.error('No variant ID found');
    }
  } else {
    console.log('Not available, cannot add to cart');
  }
});

$("body").on("click", ".remove--line-item", function(e) {
  e.preventDefault();
  var key = $(this).attr("key");

  var data = { updates: {} };
  data.updates[key] = 0;
  setTimeout(function() {
    $('.cart__item--container[key="' + key + '"]').remove();
  }, 300);
  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: data,
    dataType: "json",
    success: function() {
      updateCartData(false);
      renderCart();
      document.dispatchEvent(new CustomEvent("update-reco-drawer"));
    },
    error: function(error) {
      console.log(error);
    }
  });
});

$('body').on('click', '.qty-change', function(e) {
  e.preventDefault();
  var $this = $(this);
  var variantId = $this.data('variant-id');
  var $input = $('input[variant-id="' + variantId + '"]');
  var currentQty = parseInt($input.val(), 10);
  var changeType = $this.data('change-type');

  if (changeType === 'plus') {
    currentQty += 1;
  } else if (changeType === 'minus' && currentQty > 1) {
    currentQty -= 1;
  } else if (changeType === 'minus' && currentQty == 1){
    currentQty -= 1;
  }

  $input.val(currentQty);

  var data = {updates: {}};
  data.updates[variantId] = currentQty;

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function() {
      renderCart();
      updateCartData( false);
    },
    error: function(error) {
      console.log('erreur');
      console.log(error)
    }
  });
});

var updateCount = function(){
  var url = "/cart";
  if (window.general.langue !== "fr") {
    url = `/${window.general.langue}/cart`;
  }
  $.ajax({
    type: "GET",
    url: url,
    dataType: "json",
    success: function(response) {
      var empty = response.item_count === 0 ? true : false;
      if (empty) {
        $(".items--count").text(0);
      } else {
        $(".items--count").text(response.item_count);
      }
    },
    error: function(error) {
      console.log(error);
    }
  });
}

function klaviyoCart(response){
  var _learnq = window._learnq || [];
  var cart = {
    total_price: response.total_price/100,
    $value: response.total_price/100,
    total_discount: response.total_discount,
    original_total_price: response.original_total_price/100,
    items: response.items
  }
  _learnq.push(['track', 'Added to Cart', cart]);
}

var updateCartData = function(add) {
  var url = "/cart";
  if (window.general.langue !== "fr") {
    url = `/${window.general.langue}/cart`;
  }
  $.ajax({
    type: "GET",
    url: url,
    dataType: "json",
    success: function(response) {

      if (add == true){
        klaviyoCart(response)
      }

      var total = response.total_price;
      var empty = response.item_count === 0 ? true : false;
      updateDeliveryModule(total);
      if (empty) {
        $(".cart--body").addClass("flex flex-col justify-center items-center");
        $(".total-drawer--container, #drawer__cart--exta-infos").addClass("hidden");
        $(".empty__cart--drawer").removeClass("hidden");
        $(".items--count").text(0);
        $('.reco-mobile--container').addClass('hide-reco-mobile')

        if ($("#full__cart--title").length > 0) {
          location.reload(true);
        }
        $('#deliver--cart-drawer').addClass('hidden')
      } else {
        if (response.item_count > 2){
          $('.reco-mobile--container').addClass('hide-reco-mobile')
        } else {
          $('.reco-mobile--container').removeClass('hide-reco-mobile')
        }
        $(".cart--body").removeClass(
          "flex flex-col justify-center items-center"
        );
        $(".total-drawer--container, #drawer__cart--exta-infos").removeClass("hidden");
        $(".empty__cart--drawer").addClass("hidden");
        $(".cart__total--drawer").text(displayPrice(total));

        $(".items--count").text(response.item_count);
        $('#deliver--cart-drawer').removeClass('hidden')
      }
    },
    error: function(error) {
      console.log(error);
    }
  });
};

var renderCart = function() {
  var url = "/cart?view=sidecart&timestamp=" + Date.now();

  if (window.general.langue !== "fr") {
    url =
      `/${window.general.langue}/cart?view=sidecart&timestamp=` + Date.now();
  }

  if (window.general.cart === "true") {
    url = "/cart?view=page&timestamp=" + Date.now();
  }

  $.ajax({
    type: "GET",
    url: url,
    success: function(content) {
      var newCart = content;
      $(".cart__items__and__header--container").remove();
      $(".cart--body").append(newCart);

      if (window.location.href.indexOf("/cart") > -1) {
        $("#cart--title, .side-bar-cart").remove();
        $(".form-cart")
          .removeClass("grid-cols-[calc(75%-20px)_calc(25%-20px)] gap-x-[40px]")
          .addClass("grid-cols-1");
      }
    },
    error: function(error) {
      console.log(error);
    }
  });
};

document.addEventListener(
  "cart:open",
  function() {
    $("#cart__drawer").addClass("opened");
    $("#page__overlay").addClass("opened").attr("for", "drawer");
    setTimeout(function() {
      $("#drawer__cart--exta-infos").addClass("opened");
    }, 350);
  },
  false
);

if (window.cart) {
  var deliveryModuleWidth = 100;

  var nbSteps = window.cart.nbSteps;
  if (nbSteps > 1 && nbSteps < 3) {
    deliveryModuleWidth = 33.33;
  } else if (nbSteps > 2) {
    deliveryModuleWidth = 25;
  }

  var shippingBarLogic = function(total) {
    var currentStep = 1;
    if (total >= window.cart.steps[0] && total < window.cart.steps[1]) {
      currentStep = 2;
    } else if (total >= window.cart.steps[1]) {
      currentStep = 3;
    }

    var remainMoney = 0;
    var remainPercentage = 0;
    var colorBar = 0;

    var barCalculus = function(step, total) {
      var seuilSuivant = window.cart.steps[step - 1];
      var seuilPrecedent = 0;
      if (step !== 1) {
        seuilPrecedent = window.cart.steps[step - 2];
      }

      remainMoney = Math.max(0, (seuilSuivant - total) / 100);
      remainPercentage = Math.max(
        0,
        (seuilSuivant - total) / (seuilSuivant - seuilPrecedent)
      );
      colorBar =
        deliveryModuleWidth * step - deliveryModuleWidth * remainPercentage;
    };

    var finalStep = function() {
      remainMoney = 0;
      remainPercentage = 0;
      colorBar = 100;
    };

    switch (currentStep) {
      case 1:
        barCalculus(1, total);
        break;
      case 2:
        barCalculus(2, total);
        break;
      case 3:
        barCalculus(3, total);
        break;
      default:
        break;
    }

    $("#progress__bar--remain").css("width", colorBar + "%");

    if (remainMoney > 0) {
      var moinsDix = remainMoney < 10;
      remainMoney = remainMoney.toString().replace(".", ",");
      if (moinsDix && remainMoney.length === 3) {
        remainMoney += "0";
      } else if (!moinsDix && remainMoney.length === 4) {
        remainMoney += "0";
      }

      $("#free__shipping--message").hide();
      $("#remain__shipping__amount--message").show();
      if (
        window.translate.currency === "$" ||
        window.translate.currency === "£"
      ) {
        $("#amount__remaining").text(
          `${window.translate.currency} ${remainMoney}`
        );
      } else {
        $("#amount__remaining").text(
          `${remainMoney} ${window.translate.currency}`
        );
      }
    } else {
      $("#free__shipping--message").show();
      $("#remain__shipping__amount--message").hide();
    }
  };

  var getCartTotal = function(callback, cart) {
    if (cart) {
      if (callback) {
        callback(cart.total_price);
      } else {
        return cart.total_price;
      }
    } else {
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function(cart) {
          if (callback) {
            callback(cart.total_price);
          } else {
            return cart.total_price;
          }
        }
      });
    }
  };

  var initializeDeliveryModule = function() {
    getCartTotal(shippingBarLogic);
  };

  if (window.cart.emptyCart === false) {
    setTimeout(function() {
      initializeDeliveryModule();
    }, 1000);
  }

  var updateDeliveryModule = function(total) {
    if (window.cart.deliveryModule) {
      if (total) {
        shippingBarLogic(total);
      } else {
        getCartTotal(shippingBarLogic);
      }
    }
  };
}

document.addEventListener(
  "update-reco-drawer",
  function() {
    var url = `https://${window.location.hostname}/?section_id=reco-lateral`;
    if (window.general.langue !== "fr") {
      url = `https://${window.location.hostname}/${window.general.langue}/?section_id=reco-lateral`;
    }
    if (window.matchMedia("(max-width: 950px)" ).matches) {
      /*$.ajax({
        type: "GET",
        url: url,
        success: function(data) {
          $("#product-reco-mobile--container").empty().append(data);
          deferSrcImages("defer--reco");
        },
        error: function(error) {
          console.log("erreur");
          console.log(error);
        }
      });*/
    } else {
      $.ajax({
        type: "GET",
        url: url,
        success: function(data) {
          $("#product-reco--container").empty().append(data);
          deferSrcImages("defer--reco");
        },
        error: function(error) {
          console.log("erreur");
          console.log(error);
        }
      });
    }

  },
  false
);


$('body').on('click', '.choice-taille-reco', function(){
  var available = $(this).attr('variant-available')
  if (available == "true"){
    $('.choice-taille-reco').removeClass('border-black').addClass('border-white')
    $(this).addClass('border-black').removeClass('border-white')
    var variantId = $(this).attr('variant-id')
    var productId = $(this).attr('product-id')

    $(`.add_to_cart_reco[product-id=${productId}]`).attr('variant-id', variantId)
  }
})
if (window.collection) {
  var selectedInput = $('.select__custom--value[value="' + window.collection.defaultSortBy + '"]').first().text();

  $('.select__custom--value[value="' + window.collection.defaultSortBy + '"]').addClass("bg-black text-white active-sort").removeClass('text-black');

  $(".select__custom--selected-value").text(selectedInput);
}

$('body').on('click', '.see-more-collection', function(){
  var link = $(this).attr('link')
  var maxHeight
  if (link === window.translate.color){
    maxHeight = 'max-h-[54px]'
  } else {
    maxHeight = 'max-h-[87px]'
  }
  $(this).siblings('.filter-group-display__list').removeClass(`overflow-hidden ${maxHeight}`)
  $(this).text(window.translate.see_less).removeClass('see-more-collection').addClass('see-less-collection')
})

$('body').on('click', '.see-less-collection', function(){
  var link = $(this).attr('link')
  var maxHeight
  if (link === window.translate.color){
    maxHeight = 'max-h-[54px]'
  } else {
    maxHeight = 'max-h-[87px]'
  }
  $(this).siblings('.filter-group-display__list').addClass(`overflow-hidden ${maxHeight}`)
  $(this).text(window.translate.see_more).addClass('see-more-collection').removeClass('see-less-collection')
})
$(document).ready(function() {
  if (
    window.location.href.indexOf("collections/") > -1 &&
    window.general.collection
  ) {
    // Filters
    $("body").on("click", ".reinitialize__filters", function() {
      window.collection.currentFilters = [];
      $(".reinitialize__filters").hide();
      $(`.filter__button`).removeClass("is__active");
      var sortBy = $(
        "#sort__by--container .select__custom--value.active-sort"
      ).attr("value");
      var filteredUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.collection.collectionUrl +
        "?sort_by=" +
        sortBy;
      if (history.replaceState) {
        window.history.replaceState({ path: filteredUrl }, "", filteredUrl);
      }
      $.ajax({
        type: "GET",
        url: filteredUrl + "&view=filtered",
        success: function(content) {
          var count = parseInt(content.substring(0, 4));
          $(".filter-count").text(count);
          $("#collection__list--container").remove();
          $("#collection__page--desktop").append(content.substring(4));
        },
        error: function(error) {
          console.log(error);
        }
      });
    });

    var collectionFilter = {};
    if ($("[collection-filter]").html()) {
      collectionFilter = JSON.parse($("[collection-filter]").html());
    }

    //Range slider price
    var $range = $(".js-range-slider"),
      $from = $(".from"),
      $to = $(".to"),
      range,
      min = $range.data("min"),
      max = $range.data("max"),
      from,
      to;

    var updateValues = function() {
      $from.prop("value", from);
      $to.prop("value", to);

      dataFilter = boucleFilter();
      printUrl(dataFilter);
    };

    var updateFilter = function() {
      var maxRange = collectionFilter.filterMaxRange / 100;
      if (from === "0" && to === maxRange) {
        $('.active-filters__remove-filter[filtername="filter-price"]').hide();
      } else {
        $('.active-filters__remove-filter[filtername="filter-price"]').show();
        if (
          window.translate.currency === "$" ||
          window.translate.currency === "£"
        ) {
          $(".min-value-filter").text(window.translate.currency + from);
          $(".max-value-filter").text(window.translate.currency + to);
        } else {
          $(".min-value-filter").text(from + window.translate.currency);
          $(".max-value-filter").text(to + window.translate.currency);
        }
      }
    };

    $range.ionRangeSlider({
      onFinish: function(data) {
        from = data.from;
        to = data.to;
        updateValues();
        updateFilter();
        if (
          window.translate.currency === "$" ||
          window.translate.currency === "£"
        ) {
          $(".irs-from, .irs-to").prepend(window.translate.currency);
        } else {
          $(".irs-from, .irs-to").append(window.translate.currency);
        }
      }
    });

    $(window).bind("load", function() {
      if (
        window.translate.currency === "$" ||
        window.translate.currency === "£"
      ) {
        $(".irs-from, .irs-to").prepend(window.translate.currency);
      } else {
        $(".irs-from, .irs-to").append(window.translate.currency);
      }
    });

    range = $range.data("ionRangeSlider");
    var updateRange = function() {
      range.update({
        from: from,
        to: to
      });
    };

    $from.on("input", function() {
      from = +$(this).prop("value");
      if (from < min) {
        from = min;
      }
      if (from > to) {
        from = to;
      }
      updateValues();
      updateRange();
      updateFilter();
    });

    $to.on("input", function() {
      to = +$(this).prop("value");
      if (to > max) {
        to = max;
      }
      if (to < from) {
        to = from;
      }
      updateValues();
      updateRange();
      updateFilter();
    });

    $(document).ready(function() {
      if (collectionFilter.filterMaxValue !== "") {
        to = collectionFilter.filterMaxValue / 100;
      }
      if (collectionFilter.filterMinValue !== "") {
        from = collectionFilter.filterMinValue / 100;
      }
      updateRange();
    });

    var clearFilter = function() {
      var url = window.location.href;
      var matches = url.match(/[a-z\d]+=[a-z\d]+/gi);
      var count = matches ? matches.length : 0;
      if (window.location.search.indexOf("page=") > -1) {
        count = count - 1;
      }
    };

    $(document).ready(function() {
      clearFilter();
    });

    var dataFilter = [];

    var boucleFilter = function() {
      var array = [];
      $(".filter-group-display__list").each(function() {
        var containerFilter = $(this).children(
          ".filter-group-display__list-item"
        );

        var checkbox = containerFilter
          .children(".filter--container")
          .children(".checkbox-filter--container");
        var value = "";
        var name = checkbox.attr("name");
        var compteurCheck = 0;
        var loopCheckbox;
        var count = 0
        if (name === "filter.p.m.custom.couleur_produit") {
          for (let i = 1; i <= containerFilter.length; i++) {
            loopCheckbox = containerFilter
              .children(".filter--container")
              .children(".checkbox-" + i);

            if (loopCheckbox.hasClass("checked")) {
              compteurCheck += 1;

              value = loopCheckbox.attr("value");
              array.push({ type: name, value: value });
            }
          }
        } else {
          for (let i = 1; i <= containerFilter.length; i++) {
            loopCheckbox = containerFilter
              .children(".filter--container")
              .children(".checkbox-" + i);

            if (loopCheckbox.hasClass("checked")) {
              if (name === "filter.v.option.taille" && count < 1) {
                array.push({ type: "filter.v.availability", value: 1 });
                count = 1
              }

              compteurCheck += 1;

              compteurCheck === 1 ?
                (value = loopCheckbox.attr("value")) :
                (value = value + "," + loopCheckbox.attr("value"));
            }
          }
          compteurCheck > 0 ? array.push({ type: name, value: value }) : null;
        }
      });

      var nameFilterLow = $("#lowPriceFilter").attr("name");
      var valueLow = $("#lowPriceFilter").val();

      var nameFilterHigh = $("#highPriceFilter").attr("name");
      var valueHigh = $("#highPriceFilter").val();
      var maxValueHigh = $("#highPriceFilter").attr("max");

      if (parseInt(valueLow) > 0) {
        array.push({ type: nameFilterLow, value: valueLow });
      }

      if (parseInt(valueHigh) < parseInt(maxValueHigh)) {
        array.push({ type: nameFilterHigh, value: valueHigh });
      }

      return array;
    };

    function printUrl(list) {
      var filteredUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.collection.collectionUrl +
        "?";
      for (var filter in list) {
        filteredUrl += list[filter].type + "=" + list[filter].value + "&";
      }

      var sortBy = $(
        "#sort__by--container .select__custom--value.active-sort"
      ).attr("value");
      var filterSortBy = "sort_by=" + sortBy;

      var pageUrl = "";
      /*if (window.location.href.indexOf('page=') > -1){
        var url_string = window.location.href
        var url = new URL(url_string);
        var numberPage = url.searchParams.get("page");
        pageUrl = "&page=" + numberPage
      }*/

      var finalUrl = filteredUrl + filterSortBy + pageUrl;

      if (history.replaceState) {
        window.history.replaceState({ path: finalUrl }, "", finalUrl);
      }

      $.ajax({
        type: "GET",
        url: finalUrl + "&view=filtered",
        success: function(content) {
          var count = parseInt(content.substring(0, 4));
          $(".filter-count").text(count);
          $("#collection__list--container").remove();
          $("#collection__page--desktop").append(content.substring(4));

          clearFilter();
        },
        error: function(error) {
          console.log(error);
        }
      });
    }

    if (window.location.href.indexOf("collections") > -1) {
      dataFilter = boucleFilter();
    }

    $("body").on("click", ".filter--container", function() {
      var filterTaille = $(this)
        .find(".checkbox-filter--container")
        .attr("name");
      var filterName;
      if ($(this).find(".checkbox-filter--container").hasClass("checked")) {
        filterName = $(this)
          .find(".checkbox-filter--container")
          .attr("filtername");
        $(`.active-filters__remove-filter[filtername=${filterName}]`).remove();
      } else {
        filterName = $(this)
          .find(".checkbox-filter--container")
          .attr("filtername");

        var filterValue = "";
        if (filterName === "Disponibilité-Enstock") {
          filterValue = "En stock";
        } else if (filterTaille === "filter.v.option.taille") {
          /*$(".taille--container").removeClass("checked");
          $(".taille--container")
            .children(".checkbox-filter--container")
            .removeClass("checked");*/
        } else {
          filterValue = $(this)
            .find(".checkbox-filter--container")
            .attr("value");
        }
        $(".active-filters").append(`
        <a class="active-filters__remove-filter cursor--pointer" filtername="${filterName}">
            ${filterValue} X
        </a>
      `);
      }

      var checkboxContainer = $(this).children(".checkbox-filter--container");
      checkboxContainer.hasClass("checked") ?
        checkboxContainer.removeClass("checked") :
        checkboxContainer.addClass("checked");
      $(this).hasClass("checked") ?
        $(this).removeClass("checked") :
        $(this).addClass("checked");

      dataFilter = boucleFilter();

      printUrl(dataFilter);
    });

    var countEuro = 2;
    $("body").on("click", ".filter-group-summary", function() {
      if ($(this).hasClass("checked")) {
        $(this).removeClass("checked");
        $(this).siblings(".filter-group-display").slideToggle(200);
        $(this).children(".plus__icon").removeClass("opened");
      } else {
        $(this).addClass("checked");
        $(this).siblings(".filter-group-display").slideToggle(200);
        $(this).children(".plus__icon").addClass("opened");

        setTimeout(function() {
          if (countEuro === 1) {
            countEuro = countEuro + 1;
            if (
              window.translate.currency === "$" ||
              window.translate.currency === "£"
            ) {
              $(".irs-from, .irs-to").prepend(window.translate.currency);
            } else {
              $(".irs-from, .irs-to").append(window.translate.currency);
            }
          }
        }, 200);
      }
    });

    $("body").on("click", ".see-more", function() {
      var which = $(this).attr("which");
      $(`.see-more[which="${which}"]`).hide();
      $(`.see-less[which="${which}"]`).show();

      $(`.filter-group-display.${which}--container`).addClass("opened");
    });

    $("body").on("click", ".see-less", function() {
      var which = $(this).attr("which");
      $(`.see-more[which="${which}"]`).show();
      $(`.see-less[which="${which}"]`).hide();

      $(`.filter-group-display.${which}--container`).removeClass("opened");
    });

    $("body").on("click", ".active-filters__clear", function() {
      var link = $(this).attr("link");
      $(".filter--container, .checkbox-filter--container").removeClass(
        "checked"
      );
      $("#lowPriceFilter").attr("value", 0);
      var maxRangeValue = collectionFilter.filterMaxRange / 100;

      $("#highPriceFilter").attr("value", maxRangeValue);
      $("#highPriceFilter").val(maxRangeValue);
      to = maxRangeValue;
      from = 0;
      updateValues();
      updateRange();
      if (
        window.translate.currency === "$" ||
        window.translate.currency === "£"
      ) {
        $(".irs-from, .irs-to").prepend(window.translate.currency);
      } else {
        $(".irs-from, .irs-to").append(window.translate.currency);
      }
      window.history.replaceState({ path: link }, "", link);

      //var countFilterActive = 0;
      $(".count-filter--container").addClass("hide");

      $.ajax({
        type: "GET",
        url: link + "&view=filtered",
        success: function(content) {
          var count = parseInt(content.substring(0, 4));
          $(".filter-count").text(count);
          $(
            "#collection__list--container, .collection-remove--container"
          ).remove();
          $("#collection__page--desktop").append(content.substring(4));

          clearFilter();
          $('#filter-collection-drawer .close').click()
        },
        error: function(error) {
          console.log(error);
        }
      });
    });
  }
});

// Ouvrir la modal au clic
$("body").on("click", ".button__action", function(e) {
  e.preventDefault();
  let buttonFor = $(this).attr("for");
  let selector = $(this).attr("open-selector");

  if (selector) {
    $(selector).addClass("opened");
    $("#page__overlay").addClass("opened");
  }

  if (buttonFor === "drawer" && selector) {
    $("#page__overlay").attr("for", "drawer");
  } else if (buttonFor === "drawer-cart" && selector) {
    $("#page__overlay").attr("for", "drawer");
    setTimeout(function() {
      $("#drawer__cart--exta-infos").addClass("opened");
    }, 350);
  } else if (buttonFor === "accordeon") {
    var isActive = false;
    if ($(this).hasClass("active")) {
      isActive = true;
    }
    if ($(this).hasClass("link--item-button")) {
      $(".link--item-button.active")
        .siblings(".accordeon__list")
        .removeClass("opened")
        .slideToggle("500");
      $(".link--item-button.active")
        .children(".plus__icon")
        .removeClass("opened");
      $(".link--item-button.active").removeClass("active");
    } else if ($(this).hasClass("sub__link--item-button")) {
      $(".sub__link--item-button.active")
        .siblings(".accordeon__list")
        .removeClass("opened")
        .slideToggle("500");
      $(".sub__link--item-button.active")
        .children(".plus__icon")
        .removeClass("opened");
      $(".sub__link--item-button.active").removeClass("active");
    }

    if (isActive === false) {
      $(this).toggleClass("active");
      $(this).children(".plus__icon").toggleClass("opened");
      $(this)
        .siblings(".accordeon__list")
        .addClass("opened")
        .slideToggle("500");
    }
  } else if (buttonFor === "modal" && selector) {
    $("#page__overlay").attr("for", "modal");
  }
});

// Fermer la modal au clic sur la croix
$("body").on("click", ".close", function(e) {
  e.preventDefault();
  let closeFor = $(this).attr("for");

  $("#page__overlay").removeClass("opened");
  $("#page__overlay").attr("for", "");

  if (closeFor === "drawer") {
    $(".drawer").removeClass("opened");
  } else if (closeFor === "modal") {
    $(".modal").removeClass("opened");
    $(".modal-loader").show();
    $(".modal-has-to-load").hide();
  }
});

// Clic en dehors de la'modal'
$("#page__overlay").on("click", function(e) {
  e.preventDefault();
  let overlayFor = $(this).attr("for");

  $(this).removeClass("opened");
  $("#page__overlay").attr("for", "");

  if (overlayFor === "drawer") {
    $(".drawer").removeClass("opened");
  } else if (overlayFor === "modal") {
    $(".modal").removeClass("opened");
    $(".modal-loader").show();
    $(".modal-has-to-load").hide();
  }
});

$("body").on(
  "click",
  ".select__custom--selected-value-container",
  function() {
    var forSelect = $(this).attr("for");

    $('.select__custom--values[for="' + forSelect + '"]')
      .fadeToggle(50)
      .addClass("opened");
    $('.select__custom--values:not([for="' + forSelect + '"])')
      .hide()
      .removeClass("opened");

    $(this).children(".icon--arrow-bottom").toggleClass("opened");
    $(
      '.select__custom--selected-value-container:not([for="' +
        forSelect +
        '"])'
    )
      .children(".icon--arrow-bottom")
      .removeClass("opened");
  }
);

$("body").on("click", ".select__custom--value", function() {
  var forSelect = $(this).attr("for");
  var value = $(this).attr("value");
  var valueText = $(this).text();

  $('.select__custom--value[for="' + forSelect + '"]').removeClass(
    "bg-black text-white active-sort"
  ).addClass('text-black');
  $(this).addClass("bg-black text-white active-sort").removeClass('text-black');
  $(".select__custom--selected-value-container")
    .children(".icon--arrow-bottom")
    .removeClass("opened");
  $('.select__custom--selected-value[name="' + forSelect + '"]').text(
    valueText
  );
  $('.select__hidden[for="' + forSelect + '"]')
    .val(value)
    .trigger("change");
  $(".select__custom--values").hide().removeClass("opened");
  document.dispatchEvent(new CustomEvent(`select-changed:product__option`));
});

$(document).on("click", function(e) {
  var product = $(".select__custom--values");
  var product2 = $(".click-select");
  if (product.is(e.target) || product2.is(e.target)) {
  } else {
    if (product.hasClass("opened")) {
      $(product).hide().removeClass("opened");
      $(".select__custom--selected-value-container")
        .children(".icon--arrow-bottom")
        .removeClass("opened");
    }
  }
});

Shopify.queryParams = {};
if (location.search.length) {
  for (
    var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
    i < aCouples.length;
    i++
  ) {
    aKeyValue = aCouples[i].split("=");
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
        decodeURIComponent(aKeyValue[1]);
    }
  }
}
$('.select__hidden[for="sort--by"]').bind("change", function() {
  console.log("passe sort by");
  Shopify.queryParams.sort_by = $(this).val();
  var filteredUrl = window.location.href;

  var url = new window.URL(window.location.href);
  url.searchParams.set("sort_by", Shopify.queryParams.sort_by);

  filteredUrl = url.toString().replace("%2C", ",");

  if (history.replaceState) {
    window.history.replaceState({ path: filteredUrl }, "", filteredUrl);
  }

  $.ajax({
    type: "GET",
    url: filteredUrl + "&view=filtered",
    success: function(content) {
      var count = parseInt(content.substring(0, 4));
      $(".filter-count").text(count);
      $("#collection__list--container").remove();
      $("#collection__page--desktop").append(content.substring(4));

      //clearFilter()
    },
    error: function(error) {
      console.log(error);
    }
  });
});

var prevArrow = `<svg class="slick-arrow--left absolute top-[50%] translate-y-[-50%] w-[50px] h-[50px] left-[60px] 3xl:left-[40px] 2xl:left-[20px] z-[2] cursor-pointer" viewBox="0 0 53.4 18.8"><path style="fill:#404040;" d="M0,9.3V10a.1.1,0,0,0,.1.1v.1h0l.1.1h0l10,8a1,1,0,0,0,1.2-1.6L3.6,10.5H51.9a.94.94,0,0,0,1-1,.94.94,0,0,0-1-1H3.8l7.8-6.2A1.08,1.08,0,0,0,11.8.9,1.23,1.23,0,0,0,11,.5a1.42,1.42,0,0,0-.6.2l-10,8h0l-.1.1h0v.1L.2,9C0,9.2,0,9.2,0,9.3Z"/></svg>`;
var nextArrow = `<svg class="slick-arrow--right absolute top-[50%] translate-y-[-50%] w-[50px] h-[50px] right-[60px] 3xl:right-[40px] 2xl:right-[20px] z-[2] cursor-pointer" x="0px" y="0px"viewBox="0 0 53.4 18.8" style="enable-background:new 0 0 53.4 18.8;" xml:space="preserve"><path style="fill:#404040;" d="M52.9,9.7V9.6V9.5c0,0,0,0,0-0.1s0,0,0-0.1V9.2V9.1V9c0,0,0-0.1-0.1-0.1V8.8l0,0l-0.1-0.1l0,0l-10-8 c-0.4-0.3-1.1-0.3-1.4,0.2C41,1.3,41,2,41.5,2.3l7.8,6.2H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h48.1l-7.8,6.2c-0.4,0.3-0.5,1-0.2,1.4 c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2l10-8l0,0l0.1-0.1l0,0v-0.1l0.1-0.1C52.9,9.8,52.9,9.8,52.9,9.7z"/> </svg>`;

var initSlick = function() {
  $(".background-slider").slick({
    dots: false,
    infinite: false,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000
  });


  $("#bandeau--footer-slider").slick({
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          dots: true,
          customPaging: function(slider, i) {
            return '<button class="tab"></button>';
          }
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true,
          customPaging: function(slider, i) {
            return '<button class="tab"></button>';
          },
          adaptiveHeight: true
        }
      }
    ]
  });

  $("#instagram-feed").slick({
    dots: false,
    infinite: false,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          variableWidth: true,
          infinite: true,
          slidesToShow: 1
        }
      }
    ]
  });

  $(".slider-reassurance").slick({
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          dots: true,
          customPaging: function(slider, i) {
            return '<button class="tab"></button>';
          }
        }
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2,
          dots: true,
          customPaging: function(slider, i) {
            return '<button class="tab"></button>';
          }
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true,
          customPaging: function(slider, i) {
            return '<button class="tab"></button>';
          }
        }
      }
    ]
  });

  if (window.matchMedia("(max-width: 767px)" ).matches) {
    $(".slider-infos-cart").slick({
      dots: true,
      customPaging: function (slider, i) {
        return '<button class="tab"></button>';
      },
      infinite: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }

  $(".four-product-slider").slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  /*if (window.matchMedia("(max-width: 950px)" ).matches) {
    $("#slider--product").slick({
      dots: true,
      customPaging: function(slider, i) {
        return '<button class="tab"></button>';
      },
      infinite: false,
      arrows: false,
      waitForAnimate: false,
      slidesToScroll: 1,
      slidesToShow: 1,
      adaptiveHeight: true,
    });
  }*/

  $(".slider-list-products").each(function() {
    const sectionId = $(this).data('section-id');
    const prevArrow = $(`.arrow-list-products-left[data-section-id="${sectionId}"]`);
    const nextArrow = $(`.arrow-list-products-right[data-section-id="${sectionId}"]`);
    
    $(this).slick({
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      waitForAnimate: false,
      slidesToScroll: 1,
      slidesToShow: 6,
      centerMode: true,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            centerMode: false,
            variableWidth: true
          }
        }
      ]
    });
  });

  if (window.matchMedia("(max-width: 950px)" ).matches) {

    $(".slider-title-collection").slick({
      dots: false,
      infinite: true,
      arrows: false,
      waitForAnimate: false,
      slidesToScroll: 1,
      slidesToShow: 1,
      variableWidth: true,
      centerMode: true,
      asNavFor: '.slider-image-collection'
    });
    $(".slider-image-collection").slick({
      dots: false,
      infinite: true,
      arrows: false,
      waitForAnimate: false,
      slidesToScroll: 1,
      slidesToShow: 3,
      centerMode: true,
      asNavFor: '.slider-title-collection',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });


    if ($('.slider-title-collection .one-slide').hasClass('slick-current')){
      var color = $('.slider-title-collection .one-slide.slick-current').attr('color')
      $('.slider-title-collection .one-slide.slick-current').children('.title-collection').css('color', color).addClass('active')
    }

    $('.slider-title-collection').on('afterChange', function(){
      $('.slider-title-collection .one-slide .title-collection').removeClass('active').css('color', '')
      var color = $('.slider-title-collection .one-slide.slick-current').attr('color')
      var image = $('.slider-title-collection .one-slide.slick-current').attr('image')
      var classImage = $('.slider-title-collection .one-slide.slick-current').attr('classHoverMobile')

      $('.slider-title-collection .one-slide.slick-current').children('.title-collection').css('color', color).addClass('active')
      $('.image-collections-hover').attr('src', image).attr('srcset', '').removeClass('rotate-[8deg] rotate-2 rotate-[-6deg] eight minus-six two').addClass(classImage)
    });

    $('.image-collections-hover').on('click', function(){
      var link = $('.slider-title-collection .one-slide.slick-current').attr('href')
      window.location.href = link;
    })
  }

  if (window.matchMedia("(max-width: 1200px)" ).matches) {
    $(".slider-triple-collection").slick({
      dots: true,
      customPaging: function(slider, i) {
        return '<button class="tab"></button>';
      },
      infinite: true,
      arrows: false,
      waitForAnimate: false,
      slidesToScroll: 1,
      slidesToShow: 2,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  }

  if (window.matchMedia("(max-width: 950px)" ).matches) {
    $(".slider-header").slick({
      dots: false,
      infinite: true,
      arrows: false,
      waitForAnimate: false,
      slidesToScroll: 1,
      slidesToShow: 1,
      autoplay: false,
      speed: 800,
    });

    var percentTime;
    var tick;
    var time = .1;
    var progressBarIndex = 0;

    $('.progressBarContainer .progressBar').each(function(index) {
      var loop
      if (index % 2 !== 0) {
        loop = 1
      } else {
        loop = 0
      }
      var progress = "<div class='inProgress inProgress" + loop + "'></div>";
      $(this).html(progress);
    });

    function startProgressbar() {
      resetProgressbar();
      percentTime = 0;
      tick = setInterval(interval, 10);
    }

    function interval() {
      if (($('.slider-header .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
        progressBarIndex = $('.slider-header .slick-track div[aria-hidden="false"]').data("slickIndex");
        startProgressbar();
      } else {
        percentTime += 1 / (time + 5);
        $('.inProgress' + progressBarIndex).css({
          width: percentTime + "%"
        });
        if (percentTime >= 100) {
          $('.slider-header').slick('slickNext');
          progressBarIndex++;
          if (progressBarIndex > 2) {
            progressBarIndex = 0;
          }
          startProgressbar();
        }
      }
    }

    function resetProgressbar() {
      $('.inProgress').css({
        width: 0 + '%'
      });
      clearInterval(tick);
    }
    startProgressbar();
    // End ticking machine

    $('.item').click(function () {
      clearInterval(tick);
      var goToThisIndex = $(this).find("span").data("slickIndex");
      $('.slider-header').slick('slickGoTo', goToThisIndex, false);
      startProgressbar();
    });
  }
};

initSlick();

document.addEventListener(
  "theme-editor--slick",
  function() {
    $(".background-slider").filter(".slick-initialized").slick("unslick");
    $(".carousel-product-list").filter(".slick-initialized").slick("unslick");
    $(".blog-slider").filter(".slick-initialized").slick("unslick");
    $("#instagram-feed").filter(".slick-initialized").slick("unslick");
    $("#bandeau--footer-slider").filter(".slick-initialized").slick("unslick");

    initSlick();
  },
  false
);

$(window).on("load", function() {
  $("#announcement--container .text-slide").css("opacity", "1");
});

if (window.matchMedia("(max-width: 767px)").matches) {
  $("#sidebar-accordion-footer .plus__icon").show();
  $("#sidebar-accordion-footer")
    .find("li.extend")
    .click(function() {
        if ($(this).hasClass("first-div-footer")){
            $(this).removeClass('first-div-footer')
            $(this)
                .children(".nav__footer--title")
                .children(".plus__icon")
                .toggleClass("opened");
            $(this).toggleClass("active");
        } else {
            $(this)
                .children(".extended-submenu")
                .slideToggle("fast")
                .css("display", "flex");
            $(this)
                .children(".nav__footer--title")
                .children(".plus__icon")
                .toggleClass("opened");
            $(this).toggleClass("active");
        }


    });
}

$(window).on("resize", function() {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $("#sidebar-accordion-footer .extended-submenu").hide();
  }
  if (window.matchMedia("(min-width: 768px)").matches) {
    $("#sidebar-accordion-footer .extended-submenu").show();
  }
});


if (window.matchMedia("(max-width: 767px)" ).matches) {
    $(document).ready(function(){
        setTimeout(function(){
            $('.first-div-footer').addClass('active')
            $('.first-div-footer').find('.plus__icon').addClass('opened')
        }, 200);

        $("#sidebar-accordion-footer")
            .find("li.extend")
            .click(function() {

            })
    })
}
var pageOverlayOpened = false;
$(".navigation__item--link-megamenu").mouseenter(function() {
  if (pageOverlayOpened === false) {
    $("#page__overlay--navigation").addClass("opened");
    pageOverlayOpened = true;
  }
});

$(".navigation__item--link-megamenu").mouseleave(function() {
  if (pageOverlayOpened === true) {
    $("#page__overlay--navigation").removeClass("opened");
    pageOverlayOpened = false;
  }
});

// Gestion de la hauteur du drawer sur mobile
// a utiliser si le drawer ne fait pas 100% de l'ecran, sinon on peut commenter
var navbarHeightMobile;
var hasTransparent = false

if (window.general.headerTransparent === true){
  hasTransparent = true
}

if (hasTransparent === true) {
  $('#navigation--container').mouseenter(function() {
    $('#navigation--container').removeClass('transparent-header')
  })

  $('#navigation--container').mouseleave(function() {
    if ($(document).scrollTop() > 20) {

    } else {
      $('#navigation--container').addClass('transparent-header');
      /*var attr = $('#LanguageList').attr('name');

      if (typeof attr == 'undefined') {
        $('.disclosure__button').click()
      }*/
    }
  })
}

if ($(document).scrollTop() > 20) {
  navbarHeightMobile = 40;
  if (hasTransparent === true){
    $('#navigation--container').removeClass('transparent-header')
  }
} else {
  navbarHeightMobile = 74;
  if (hasTransparent === true){
    $('#navigation--container').addClass('transparent-header')
  }
}
$("#navigation__drawer, #cart__drawer, #filter-collection-drawer").css("height", window.innerHeight); // init
$(document).on("scroll", function() {
  if ($(document).scrollTop() > 20) {
    navbarHeightMobile = 40;
    if (hasTransparent === true){
      $('#navigation--container').removeClass('transparent-header')
    }
  } else {
    navbarHeightMobile = 74;
    if (hasTransparent === true){
      $('#navigation--container').addClass('transparent-header')
    }
  }
  $("#navigation__drawer, #cart__drawer, #filter-collection-drawer").css("height", window.innerHeight);
});

var handleSearchBar = function(
  searchTriggerId,
  positionScrolledClass,
  positionClass,
  translateYScrolled,
  translateY
) {
  $(searchTriggerId).on("click", function() {
    if (
      $(".search--container").hasClass(positionScrolledClass) ||
      $(".search--container").hasClass(positionClass)
    ) {
      $("#page__overlay--navigation").removeClass("opened");
      $(".navigation__item--container").removeClass("search--opened");
      $("#navigation--container").removeClass("fixedWhiteNav");
      $(".search--container")
        .removeClass(`${positionScrolledClass} ${positionClass}`)
        .css("transform", "");
      $(".searchProduct").val("");
      $(".result-search").html("");
      $(".popular_product").removeClass("opened");
    } else {
      $("#page__overlay--navigation").addClass("opened");
      $("#navigation--container")
        .addClass("fixedWhiteNav")
        .removeClass("transparent--nav");
      $(".popular_product").addClass("opened");
      if ($(document).scrollTop() >= 20) {
        $(".search--container").addClass(positionScrolledClass);
        $(
          `.search--container.${positionClass}, .search--container.${positionScrolledClass}`
        ).css("transform", `translateY(${translateYScrolled}px)`);
      } else {
        var topPosition = translateY - $(document).scrollTop();
        $(".search--container").addClass(positionClass);
        $(
          `.search--container.${positionClass}, .search--container.${positionScrolledClass}`
        ).css("transform", `translateY(${topPosition}px)`);
      }
    }
    $(".searchProduct.search--input").focus();
  });

  $(document).on("scroll", function() {
    if ($(document).scrollTop() >= 20) {
      $(
        `.search--container.${positionClass}, .search--container.${positionScrolledClass}`
      ).css("transform", `translateY(${translateYScrolled}px)`);
    } else {
      var topPosition = translateY - $(document).scrollTop();
      $(
        `.search--container.${positionClass}, .search--container.${positionScrolledClass}`
      ).css("transform", `translateY(${topPosition}px)`);
    }
  });
};

if (window.matchMedia("(max-width: 767px)").matches) {
  handleSearchBar(
    "#icon-search",
    "opened-mobile-scroll",
    "opened-mobile2",
    0,
    0
  );
} else if (window.matchMedia("(max-width: 1100px)").matches) {
  handleSearchBar(
    "#icon-search",
    "opened-mobile-scroll",
    "opened-mobile",
    0,
    0
  );
} else {
  handleSearchBar("#icon-search", "opened-scroll", "opened", 0, 0);
}

var handleCloseSearch = function() {
  console.log('passe')
  $(".searchProduct").val("");
  $(".result-search").html("");
  $(".search--container")
    .removeClass(
      "opened opened-scroll opened-mobile-scroll opened-mobile opened-mobile2"
    )
    .css("transform", "");
  $("#navigation--container").removeClass("fixedWhiteNav");
  $("#page__overlay--navigation").removeClass("opened");
  $(".navigation__item--container").removeClass("search--opened");
  $(".popular_product").removeClass("opened");
};

$(".close--search").on("click", function() {

  handleCloseSearch();
});

$(document).on("click", function(e) {
  var container = $(".search--container");
  if ($(e.target).hasClass("search--trigger")) {
  } else {
    if (
      (container.hasClass("opened") ||
        container.hasClass("opened-mobile") ||
        container.hasClass("opened-mobile2")) &&
      !container.is(e.target) &&
      container.has(e.target).length === 0
    ) {
      console.log('click passe')
      handleCloseSearch();
    }
  }
});

$(document).on("click", ".global-search", function() {
  //var url = window.location.hostname
  var search = document.getElementsByClassName("searchProduct")[0].value;
  var redirection = "/search?type=product&q=" + search;
  if (window.general.langue != 'fr'){
    redirection = `/${window.general.langue}/search?type=product&q=` + search;
  }
  window.location.replace(redirection);
  $(".search--container").removeClass("opened");
});

$(document).on("input", ".search--input", function() {
  if ($(this).attr("search") === "barre") {
    SearchFunction("searchArticle-barre", "article", "result-search-barre");
  } else if ($(this).attr("search") === "article") {
    SearchFunction("searchArticle", "article", "result-search");
  } else if ($(this).attr("search") === "produit") {
    SearchFunction("searchProduct", "product", "result-search");
  }
});

function formatPrice(price) {
  let priceNumber = parseFloat(price);

  if (priceNumber % 1 === 0) {
    return `${Math.floor(priceNumber)}`;
  } else {
    return `${priceNumber.toFixed(2).replace('.', ',')}`;
  }
}

var SearchFunction = function(classInput, typeSearch, classInputResult) {
  var htmlItem = function(type, item, index) {
    if (type === "article") {
      return (
        "<div class='one-product'><a class='flex fd--row jc--flex-start' href=" +
        item[index].url +
        "><img class='image-product' src=" +
        item[index].image +
        "><div class='content--container flex fd--column ai--flex-start'><p class='product--title text-black uppercase md:my-[5px] md:mt-0'>" +
        item[index].title +
        "</p></div></a></div>"
      );
    } else {
      var prix = "";
      if (item[index].compare_at_price_max == 0.0) {
        if (
          window.translate.currency === "$" ||
          window.translate.currency === "£"
        ) {
          prix =
            window.translate.currency + formatPrice(item[index].price);
        } else {
          prix =
            formatPrice(item[index].price) + window.translate.currency;
        }
      } else {
        if (
          window.translate.currency === "$" ||
          window.translate.currency === "£"
        ) {
          prix = `${window.translate.currency}${formatPrice(item[index].price)}<span class='line-through mx-[10px] mr-0 product--price text-[12px] ${window.general.searchText}' style='opacity: 0.3;'>${window.translate.currency}${formatPrice(item[index].compare_at_price_max)}</span>`;
        } else {
          prix = `${formatPrice(item[index].price)}${window.translate.currency}<span class='line-through mx-[10px] mr-0 product--price text-[12px] ${window.general.searchText}' style='opacity: 0.3;'>${formatPrice(item[index].compare_at_price_max)}${window.translate.currency}</span>`;
        }
      }
      return (
        `<div class='one-product'><a class='flex flex-col' href="${item[index].url}"><img class='w-full h-auto object-cover' src="${item[index].image}"><div class='flex flex-col my-[10px] mb-0'><p class='product--title uppercase md:my-[5px] md:mt-0 ${window.general.searchText}'>${item[index].title}</p><p class='price product--price flex flex-row items-center ${window.general.searchText}'>${prix}</p></div></a></div>`
      );
    }
  };

  var emptyItem = function(type) {
    if (type === "article") {
      return `<div class='empty'>${
        window.translate.strings.noArticles || ""
      }</div>`;
    } else {
      return `<div class='empty px-[20px] py-[10px] text-center col-start-1 col-end-5 2xl:col-end-3 my-[20px] mt-0 body--text uppercase ${window.general.searchText}'>${
        window.translate.strings.noProducts || ""
      }</div>`;
    }
  };

  var q = document.getElementsByClassName(classInput)[0].value;
  var b = `&resources[type]=${typeSearch}`;
  var c = "";
  if (q === "") {
    $(".result-search").html("");
    $(".result-search-barre").html("");
  }
  var type = "";
  if (typeSearch === "article") {
    type = "article";
  } else {
    type = "product";
    c = "&resources[options][fields]=title,product_type,tag";
  }
  if (q === "") {
    $(".popular_product").addClass("opened");
  } else {
    $(".popular_product").removeClass("opened");
  }
  var first;
  if (window.general.langue !== "fr") {
    first = `/${window.general.langue}/search/suggest.json?q=`;
  } else {
    first = "/search/suggest.json?q=";
  }
  $.ajax(first + q + b + c, {
    type: "GET",
    dataType: "json",
    success: function(response) {
      var itemsSuggestions = response.resources.results[`${typeSearch}s`];
      if (itemsSuggestions.length > 0) {
        var result = "";
        for (var i = 0; i < itemsSuggestions.length; i++) {
          if (
            itemsSuggestions[i].id !== 6623214993579 &&
            itemsSuggestions[i].id !== 6623216205995
          ) {
            result += htmlItem(type, itemsSuggestions, i);
          }
        }

        if (type === "product") {
          result =
            result +
            `<div class='global-search col-start-1 col-end-5 ml-[-20px] w-[calc(100%+40px)] sticky bottom-0 left-0 px-[20px] py-[10px] button__plain--color cursor-pointer button--text uppercase ${window.general.searchText == "text-25" ? window.general.searchBack : window.general.searchText} text-center 2xl:col-end-3 bg-white'>${
              window.translate.strings.moreResults || ""
            }</div>`;
        }
        $(`.${classInputResult}`).html(result);
      } else {
        var emptyProduct = emptyItem(type);
        $(`.${classInputResult}`).html(emptyProduct);
      }
    }
  });
};

$("body").on("click", ".atc", function() {
  var attribute = $(this).attr("data-atc");
  if (event.ctrlKey || $(this).hasClass("atc_blank")) {
    var newWindow = window.open(
      decodeURIComponent(window.atob(attribute)),
      "_blank"
    );
    newWindow.focus();
  } else {
    document.location.href = decodeURIComponent(window.atob(attribute));
  }
});

// Si le client veut la formule RGPD
// --> on supprime ce qui est non commente
// --> on decommente le reste

$(".button--cookie").click(function() {
  $("#cookie--banner").hide();
  $("#page__overlay--cookie").removeClass("opened");
});

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length === 2) {
return parts.pop().split(";").shift();
}
}

if (getCookie("cookies-accepted") === "yes") {
} else {
  $("#cookie--banner").addClass("apparition--cookie");
  $("#page__overlay--cookie").addClass("opened");
}

$("#accept--all, #reject--all").on("click", function() {
  var CookieDate = new Date();
  CookieDate.setMonth(CookieDate.getMonth() + 12);
  document.cookie =
    "cookies-accepted=yes; expires=" + CookieDate.toGMTString() + "; path=/";
});

$(".button__with__loading").on("click", function() {
  $(this).children(".text--loading").hide();
  $(this).children(".button--loading").css("display", "flex");
});

function deferSrcImages(className) {
  var imgDefer = document.getElementsByClassName(className);
  for (var i = 0; i < imgDefer.length; i++) {
    if (imgDefer[i].getAttribute("defer-src")) {
      imgDefer[i].setAttribute("src", imgDefer[i].getAttribute("defer-src"));
    }
  }
}

function setVideoSource(className, mediaQuery) {
  if (window.matchMedia(mediaQuery).matches) {
    var videoSources = document.getElementsByClassName(className);
    for (var i = 0; i < videoSources.length; i++) {
      var videoSource = videoSources[i];
      var videoSrc = videoSource.getAttribute('defer-src');
      if (videoSrc) {
        videoSource.setAttribute('src', videoSrc);
        videoSource.removeAttribute('defer-src');
        videoSource.parentNode.load();
      }
    }
  }
}


window.onload = function() {
  document.dispatchEvent(new CustomEvent("update-reco-drawer"));

  setTimeout(function() {
    deferSrcImages("defer--product");
  }, 200);

  setTimeout(function() {
    deferSrcImages("defer--reco");
  }, 500);

  if (window.matchMedia("(min-width: 1201px)").matches) {
    deferSrcImages("defer-desktop");
  }
  if (window.matchMedia("(max-width: 1200px)").matches) {
    deferSrcImages("defer-mobile");
  }
  if (window.matchMedia("(max-width: 950px)").matches) {
    deferSrcImages("defer-mobile-2");
  }
// Définir la source des vidéos pour desktop
  setVideoSource('defer-desktop-video', '(min-width: 768px)');

  // Définir la source des vidéos pour mobile
  setVideoSource('defer-mobile-video', '(max-width: 767px)');

};

if (window.matchMedia("(min-width: 951px)" ).matches) {
  $( ".title-collection-slide" ).on( "mouseover", function() {
    var image = $(this).attr('image')
    var classImage = $(this).attr('classHover')
    $('.image-collections-hover').attr('src', image).attr('srcset', '').removeClass('rotate-[8deg] rotate-2 rotate-[-6deg]').addClass(classImage)
  } );
} else {

}

$('.click-search-mobile').on('click', function (){
  $('#navigation__drawer .close').click()
  $('#icon-search').click()
})

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

var cartOpen = getUrlParameter('cart')
if (cartOpen == "open"){
  document.dispatchEvent(new CustomEvent('cart:open'));
}

$('#drawer-birthdate').on('input', function() {
  var input = $(this).val();
  if(input.length === 2 || input.length === 5){
    $(this).val(input + '/');
  }
});

$('.variant-grid').on('click', function(e){
  e.preventDefault()
  var link = $(this).attr('link');
  window.location.href = link;
})

if (window.general.langue != 'fr'){
  $('.logo-nav').attr('href', '/en')
  $('.checkout-cart').attr('href', '/en/checkout')
}


$("#go-top").on("click", function() {
  $("html, body").animate(
    {
      scrollTop: 0
    },
    500
  );
});

if (window.matchMedia("(max-width: 767px)" ).matches) {
  if ($(document).scrollTop() > 100) {
    $(".add__to__cart--container").show();
  } else {
    $(".add__to__cart--container").hide();
  }

  $(document).on("scroll", function() {
    if ($(document).scrollTop() > 100) {
      $(".add__to__cart--container").show();
    } else {
      $(".add__to__cart--container").hide();
    }
  });
}


var displayPrice = function(price) {
  if (window.translate.currency === "$" || window.translate.currency === "£") {
    return window.translate.currency + price / 100;
  } else {
    return price / 100 + window.translate.currency;
  }
};

$(".newsletter-form").submit(function(e) {
  e.preventDefault();
  console.log($(this))
  var $this = $(this)

  if ($(this).find('.checkbox--newsletter').hasClass("checked")) {
    $(".checkbox--email").hide();

    var index = $(this).attr("form-index");
    var email = $(this).find(`.email--newsletter[form-index="${index}"]`)
      .val()
      .toLowerCase();
    var fields = "$source,$email,$consent";

    var formData = {
      email: email,
      g: $(`.list--newsletter[form-index="${index}"]`).val(), // liste klaviyo
      $consent: "email",
      $source: $(`.newsletter-form[form-index="${index}"]`).attr("source"),
      $fields: fields
    };

    $.ajax({
      type: "POST",
      url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      data: formData,
      dataType: "json",
      success: function(response) {
        if (response.errors && response.errors.length > 0) {
          $(".newsletter-form .error--email").show();
          _learnq.push([
            "identify",
            {
              $email: email
            }
          ]);
        } else {
          $(".newsletter-form .success--email").show();
          if (window.general.specialLayout == true){
            fbq('track', 'Lead');
          }
        }
      },
      error: function(error) {
        console.log(error);
        $(".newsletter-form .error--email").show();
      }
    });
  } else {
    $(".checkbox--email").show();
  }
});

$(".click-check").on("click", function() {
  var color = 'bg-black'
  if ($(this).hasClass("checked")) {
    $(this)
      .removeClass(`checked ${color}`)
      .addClass("bg-white");
  } else {
    $(this)
      .addClass(`checked ${color}`)
      .removeClass("bg-white");
  }
});

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector(".disclosure__list")
    };
    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") {
return;
}

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) {
form.submit();
}
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define("localization-form", LocalizationForm);

if (window.general.photoSwipe === true) {
  var container = [];

  $("#slider--product")
    .find(".carousel-cell")
    .each(function() {
      /* var $link = $(this).find('.product__image'),
      item = {
        src: $link.attr('src'),
        w: $link.attr('width'),
        h: $link.attr('height')
      };*/
      var $link = $(this).find(".product__image"),
        item = {
          src: $link.attr("src"),
          w: 2300,
          h: 1536
        };
      container.push(item);
    });

  var gallery = "";
  // Define click event on gallery item
  $("body").on("click", "#slider--product .carousel-cell", function(event) {
    // Prevent location change
    event.preventDefault();

    // Define object and gallery options
    var $pswp = $(".pswp")[0],
      options = {
        index: $(this).index()
      };

    // Initialize PhotoSwipe
    gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, container, options);
    gallery.init();

    if (window.matchMedia("(max-width: 1000px)").matches) {
      $("#slider--product")
        .find(".carousel-cell")
        .each(function() {
          var id = $(this).attr("id");
          if (id !== undefined) {
            $(this)
              .find(".product__image")
              .clone()
              .appendTo(".pswp__thumbnail");
          }
        });
    } else {
      $("#slider--product img").clone().appendTo(".pswp__thumbnail");
    }

    $(".button-pswp--container, .pswp__thumbnail").addClass("opened");

    $(".pswp__thumbnail img").eq(gallery.getCurrentIndex()).addClass("active");

    gallery.listen("close", function() {
      $(".pswp__thumbnail img").remove();
      $(".button-pswp--container, .pswp__thumbnail").removeClass("opened");
    });
  });

  $("body").on("click", ".pswp__thumbnail img", function() {
    $(".pswp__thumbnail img").removeClass("active");
    $(this).addClass("active");

    var number = $(".pswp__thumbnail img").index($(this));
    gallery.goTo(number);

    $(".button-zoom-pswp").children(".see-more").removeClass("opened");
  });

  $("body").on("click", ".button-close-pswp", function() {
    gallery.close();
  });

  $("body").on("click", ".pswp", function(e) {
    if (
      !$(e.target).closest('.pswp__img').length &&
      !$(e.target).closest('.pswp__button').length
    ) {
      gallery.close();
    }
  });

  $("body").on("click", ".button-zoom-pswp", function() {
    gallery.toggleDesktopZoom();
    if ($(".pswp").hasClass("pswp--zoomed-in")) {
      $(".button-zoom-pswp").children(".see-more").addClass("opened");
    } else {
      $(".button-zoom-pswp").children(".see-more").removeClass("opened");
    }
  });

  $("body").on("click", ".pswp__img", function() {
    if ($(".pswp").hasClass("pswp--zoomed-in")) {
      $(".button-zoom-pswp").children(".see-more").addClass("opened");
    } else {
      $(".button-zoom-pswp").children(".see-more").removeClass("opened");
    }
  });
}

$("#slider__nav--product .thumb--image").on("click", function() {
  var index = $(this).attr("thumb-index");
  $("#slider__nav--product .thumb--image").removeClass(
    "border-primary border-4"
  );
  $(this).addClass("border-primary border-4");
  $("#slider--product").slick("slickGoTo", index);
});

if(window.location.href.indexOf("/products") > -1){
  if (window.matchMedia("(min-width: 951px)").matches) {
    $('body').on('click', '.swiper-zoom-container', function () {
      $(this).toggleClass('zoom-container');
    });
    $('body').on('mouseleave', '.swiper-zoom-container', function () {
      $(this).removeClass('zoom-container');
    });
  } else {
    var galleryTop = new Swiper('#slider--product', {
      zoom: {
        maxRatio: 3,
      },
      effect: 'fade',
      fade: { crossFade: true },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      loop: true,
      on: {
        click: function(e) {

          if (galleryTop.zoom.scale == 1) {
            $('.swiper-zoom-container').css('cursor', 'crosshair');
            $('.product__tags--container').hide()
            galleryTop.zoom.in();
          } else {
            $('.swiper-zoom-container').css('cursor', 'zoom-in');
            $('.product__tags--container').show()
            galleryTop.zoom.out();
          }
        },
        slideChangeTransitionStart: function(event) {
          if ($('.swiper-slide-active').find('#video-slider-product').length > 0) {
            $('.video-product-gallery--container').show();
          } else {
            $('.video-product-gallery--container').hide();
          }
          var slideNumber = $('.swiper-slide-active .product__image').attr('slide-number');
          $('#swiper__product__thumb .thumb--element').removeClass('active__slide');
          $(`#swiper__product__thumb .thumb--element[data-slider="${slideNumber}"]`).addClass('active__slide');
        }
      }
    });

    if (window.product && window.productGallery && window.productGallery.zoom == false && window.location.pathname != "/products/gift-card") {
      galleryTop.zoom.disable();
    }
  }
}


var productDetails = {};
if ($("[product-details]").html()) {
  productDetails = JSON.parse($("[product-details]").html());
}

document.addEventListener(
  "select-changed:product__option",
  function() {
    onOptionChanged();
  },
  false
);

function updateProductButton(variant, productId) {
  if (variant.available === false) {
    $(`.add__to__cart[product-id="${productId}"]`)
      .html(`${window.translate.strings.createAlert || ""}`)
      .attr("id", "BIS_trigger")
      .attr("variant-available", false)
      .attr("data-variant-id", variant.id).addClass('button__plain--secondary__color').removeClass('button__plain--primary__color');
    $('.shipping-infos').addClass('hidden')
    $('.out-stock-infos').removeClass('hidden')
  } else {
    $(`.add__to__cart[product-id="${productId}"]`)
      .html(
        `${
          window.translate.strings.addToCart || ""
        }`
      )
      .attr("id", "")
      .attr("variant-available", true).removeClass('button__plain--secondary__color').addClass('button__plain--primary__color');
    $('.shipping-infos').removeClass('hidden')
    $('.out-stock-infos').addClass('hidden')
  }
}

function onOptionChanged() {
  var productOptions = [];

  for (var i = 1; i <= 3; i++) {
    productOptions[i - 1] =
      $(
        `.select__custom--selected-value[product-id="${productDetails.productId}"][name="product__option--${i}"]`
      )
        .text()
        .trim() || "";
  }
  if (productDetails && productDetails.variants.length > 1) {
    productDetails.variants.forEach(function(variant) {
      if (
        variant.option1 === productOptions[0] &&
        variant.option2 === productOptions[1] &&
        variant.option3 === productOptions[2]
      ) {
        $(".price-js").text(variant.price);
        $(".compare-price-js").text(variant.compareAtPrice);
        var pourcentage = Math.floor(
          (1 - parseInt(variant.price) / parseInt(variant.compareAtPrice)) *
            100
        );
        var dividedThree = formatPrice(parseInt(variant.price) / 3)
        if (window.translate.currency === "$" || window.translate.currency === "£") {
          $('.dividedThree').text(`${window.translate.currency}${dividedThree}`)
        } else {
          $('.dividedThree').text(`${dividedThree}${window.translate.currency}`)
        }
        if (pourcentage) {
          $(".sales__tag--container")
            .show()
            .text("-" + pourcentage + "%");
        } else {
          $(".sales__tag--container").hide().text("");
        }
        $(`.add__to__cart[product-id="${productDetails.productId}"]`).attr(
          "variant-id",
          variant.id
        );
        var url =
          document.location.origin +
          document.location.pathname +
          `?variant=${variant.id}`;
        window.history.replaceState({ path: url }, "", url);
        var featuredImage = variant.imageId;

        var quantity = variant.availableQty
        if (quantity < 4 && quantity > 0){
          $('.infos-quantity-product').removeClass('hidden')
          var piece = window.translate.piece
          if (quantity > 1){
            piece = `${window.translate.piece}s`
          }
          $('.quantity-product').text(`${quantity} ${piece}`)
        } else {
          $('.infos-quantity-product').addClass('hidden')
        }

        // Change image on variant change
        var imageNumber =
          parseInt(
            $(
              `#slider--product .product__image[image-id="${featuredImage}"]`
            ).attr("slide-number")
          ) - 1;
        if (imageNumber) {
          $("#slider--product").slick("slickGoTo", imageNumber);
        }

        updateProductButton(variant, productDetails.productId);
      }
    });
  }
}

$(".quantity__change--selector-product").on("click", function() {
  var type = $(this).attr("type");
  var currentQty = parseInt(
    $(".product__qty--container .quantity__current").val()
  );

  if (type === "minus") {
    if (currentQty !== 0) {
      $(".product__qty--container .quantity__current").val(currentQty - 1);
    }
  } else {
    $(".product__qty--container .quantity__current").val(currentQty + 1);
  }
});

$(".bulle__custom--value").on("click touchstart", function(e) {
  e.preventDefault();

  var value = $(this).text();
  var option = $(this).attr("for");

  $('.select__custom--selected-value[for="' + option + '"]').text(value);
  $('.bulle__custom--value[for="' + option + '"]').removeClass("border-black").addClass('border-white');
  $(this).addClass("border-black").removeClass("border-white");

  document.dispatchEvent(new CustomEvent(`select-changed:product__option`));
});

if (window.location.href.indexOf("/products/") > -1) {
  var id = productDetails.productId;
  fetch(
    window.Shopify.routes.root +
      `recommendations/products.json?product_id=${id}`
  )
    .then((response) => response.json())
    .then(({ products }) => {
      console.log(products)
      if (products.length > 0) {
        for (var i = 0; i < products.length; i++) {
          if (products[i].price){
            var price = products[i].price / 100;
            var priceFinal = "";
            if (
              window.translate.currency === "$" ||
              window.translate.currency === "£"
            ) {
              priceFinal = window.translate.currency + price.toFixed(2);
            } else {
              priceFinal = price.toFixed(2) + window.translate.currency;
            }

            var comparePrice = products[i].compare_at_price / 100;
            var comparePriceFinal = "";
            if (comparePrice === 0) {
            } else {
              if (
                window.translate.currency === "$" ||
                window.translate.currency === "£"
              ) {
                comparePriceFinal =
                  window.translate.currency + comparePrice.toFixed(2);
              } else {
                comparePriceFinal =
                  comparePrice.toFixed(2) + window.translate.currency;
              }
            }

            var imageFour = products[i].images[0];
            var imageFinal, imageSplit;
            if (imageFour.includes("jpg")) {
              imageSplit = imageFour.split(".jpg");
              imageFinal = imageSplit[0] + "_500x.jpg";
            } else if (imageFour.includes("jpeg")) {
              imageSplit = imageFour.split(".jpeg");
              imageFinal = imageSplit[0] + "_500x.jpeg";
            } else if (imageFour.includes(".png")) {
              imageSplit = imageFour.split(".png");
              imageFinal = imageSplit[0] + "_500x.png";
            } else {
              imageFinal = products[i].images[0];
            }

            var available = products[i].available

            $(".slider-reco-product")
              .append(`<div class="product__item--container product-reco${i} relative mx-[12px] w-[310px] md:w-[220px] md:mx-[15px] md:ml-0 home">
              <a class="product__item__link--container z-[2] atc cursor-pointer" data-atc="${window.btoa(`${window.general.langue != 'fr' ? `/${window.general.langue}` : '' }/products/` + products[i].handle)}">
                <div class="relative">
                  ${available == true ? '' : `<p class="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-[9] h3--title uppercase text-primary w-full text-center px-[15px]">${window.translate.strings.soldOut}</p>` }
                
                  <img class="lazyload ${available == true ? 'product__item__image margin__auto w-full duration-300 transition-all' : 'product__item__image margin__auto w-full duration-300 transition-all' }" data-src="${imageFinal}" >
                </div>
            
                <div class="flex flex-col my-[10px] mb-0 relative ${products[i].compare_at_price != null ? 'pr-[55px]': '' } md:flex-col md:pr-0">
                  <h2 class="product--title text-black uppercase md:my-[5px] md:mt-0">${products[i].title}</h2>
                  <div class="product__grid--price flex flex-row product--price text-black items-center md:flex-col md:relative md:items-start">${priceFinal}
                  ${products[i].compare_at_price != null ? `<span class="line-through mx-[10px] mr-0 product--price text-black/30 text-[12px] md:ml-0">${comparePriceFinal}</span> <div class="sales__tag--container absolute top-0 right-0 bg-primary product--title text-white rounded-[11px] py-[3px] px-[5px] md:text-[12px] md:bg-primary4"></div>` : '' }
                  </div>
                </div>
              </a>
            </div>`);

            if (products[i].compare_at_price != null) {
              var solde =
                (products[i].price * -100) / products[i].compare_at_price + 100;
              var soldeFinal = Math.floor(solde) + "%";

              $(`.product-reco${i} .sales__tag--container`).text(soldeFinal);
            } else {
              $(`.product-reco${i} .sales__tag--container`).remove();
              $(`.product-reco${i} .product__grid--price-compare`).remove();
            }
          }
        }

        $(".slider-reco-product").slick({
          dots: false,
          infinite: true,
          arrows: true,
          prevArrow: $('.arrow-list-products-left'),
          nextArrow: $('.arrow-list-products-right'),
          waitForAnimate: false,
          slidesToScroll: 1,
          slidesToShow: 6,
          centerMode: true,
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 4,
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 767,
              settings: {
                arrows: false,
                centerMode: false,
                variableWidth: true
              }
            }
          ]
        });
      } else {
        $(".four-products-product").hide();
      }
    });
}

$('.accordeon-title').on('click', function(){
  if ($(this).hasClass('active')){
    $(this).removeClass('active')
    $(this).siblings('.accordeon-hidden').removeClass('active')
    $(this).find('.plus__icon').removeClass('opened')
    $(this).next().slideToggle(200)
  } else {
    $(this).addClass('active')
    $(this).siblings('.accordeon-hidden').addClass('active')
    $(this).find('.plus__icon').addClass('opened')
    $(this).next().slideToggle(200)
  }
})

$('.click-color').on('click', function(){
  if($('.div-hidden-color').hasClass('hidden')){
    $('.div-hidden-color').removeClass('hidden')
    $('.icon--arrow-bottom').addClass('opened')
  } else {
    $('.div-hidden-color').addClass('hidden')
    $('.icon--arrow-bottom').removeClass('opened')
  }
})

$(document).on('click', function(e){
  var product = $(".click-color-click");
  var divHidden = $('.div-hidden-color')
  if (product.is(e.target)) {
  } else {
    if (!divHidden.hasClass('hidden')){
      $('.div-hidden-color').addClass('hidden')
      $('.icon--arrow-bottom').removeClass('opened')
    }
  }
})

$('.click-gift').on('click', function (){
  $('.hidden-input--container').slideToggle(200)
  $('.button-add-product').toggleClass('giftCard')
})

$('.click-guide').on('click', function(){
  var link = $(this).attr('link')
  $('.div-guide').addClass('hidden')
  $(`#${link}`).removeClass('hidden')
  $('.click-guide').addClass('border-white').removeClass('border-primary')
  $(this).removeClass('border-white').addClass('border-primary')
})
$('.faq__question').on('click', function(){
  var isAlreadyOpen = $(this).next().attr('aria-hidden') === 'false';

  $('.plus__icon').removeClass('opened');
  $('.faq-question--container').find('.faq__answer[aria-hidden="false"]').not($(this).next()).slideToggle(200).attr('aria-hidden', 'true');

  if (!isAlreadyOpen) {
    $(this).children('.plus__icon').addClass('opened');
    $(this).next().slideToggle(200).attr('aria-hidden', 'false');
  } else {
    $(this).children('.plus__icon').removeClass('opened');
    $(this).next().slideToggle(200).attr('aria-hidden', 'true');
  }
});

$(document).ready(function(){
  $('.first-faq').click()
})


$(".faq-link").on("click", function() {
  var block = $(this).attr("link");
  $("html, body").animate(
    {
      scrollTop: $(block).offset().top - 150
    },
    500
  );
});

$(".order--container").on("click", function() {
  if ($(this).hasClass("follow__link") === false) {
    var orderId = $(this).attr("order-id");
    $('.order__details[order-id="' + orderId + '"]')
      .slideToggle(200)
      .toggleClass("is-active");
    $(this).toggleClass("child-active");
    $(this)
      .children(".open__line__items--link")
      .children()
      .toggleClass("rotate-180");
  }
});

if (window.location.href.indexOf("/account/register") > -1){
  document.getElementById('create_customer').addEventListener('submit', function(event) {
    event.preventDefault()

    var birthday = $('#drawer-birthdate').val()

    var dateParts = birthday.split('/');
    var isoFormattedDate = dateParts[2] + '-' + dateParts[1] + '-' + dateParts[0] + 'T09:00:00';

    $('#drawer-birthdate').val(isoFormattedDate);

    this.submit();
  });
}

});